import axios from "axios";
// Login with Api
export let ConfigApp = async (path) => {

  try {
    const url = process.env.REACT_APP_ADMIN_API_URL + path;
    let data = "";

    const response = await axios.post(
      url,
      data
    );
    return response.data
  } catch (error) {
    sessionStorage.removeItem('userSelect');
    throw error;
  }
};